import script from "./TransferMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferMenu.vue?vue&type=script&setup=true&lang=js"

import "./TransferMenu.vue?vue&type=style&index=0&id=491fb184&lang=css"

const __exports__ = script;

export default __exports__